export default "__VITE_ASSET__CVXycnDl__"